<template>
  <v-tooltip
    bottom
    :disabled="!showTooltip">
    <template #activator="{ on }">
      <v-list-item-subtitle v-on="on">
        <v-checkbox
          :input-value="value"
          :disabled="disabled"
          :ripple="false"
          hide-details
          class="mt-0"
          color="blue"
          style="max-width: 75px"
          :label="label"
          @change="$emit('change', $event)" />
      </v-list-item-subtitle>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'ProjectDetailsExportCheckbox',
  props: {
    label: {
      type: String,
      default: 'Checkbox',
    },
    value: {
      type: Boolean,
      default: false,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: 'TooltipText',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
